import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);
  return <AnimatePresence data-id="element-191">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-charcoal/60 backdrop-blur-sm" onClick={onClose} data-id="element-192">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.25,
        ease: [0.21, 0.47, 0.32, 0.98]
      }} className="bg-cream rounded-3xl shadow-2xl max-w-2xl w-full max-h-[85vh] flex flex-col overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-193">
            {/* Header */}
            <div className="flex items-center justify-between p-6 md:p-8 border-b border-charcoal/10 shrink-0" data-id="element-194">
              <h2 className="text-2xl md:text-3xl font-serif text-charcoal" data-id="element-195">
                {title}
              </h2>
              <button onClick={onClose} className="p-2 rounded-full hover:bg-charcoal/5 transition-colors text-charcoal/60 hover:text-charcoal" aria-label="Cerrar" data-id="element-196">
                <X size={24} data-id="element-197" />
              </button>
            </div>

            {/* Content */}
            <div className="overflow-y-auto p-6 md:p-8 text-charcoal/80 leading-relaxed space-y-4 prose-headings:font-serif prose-headings:text-charcoal" data-id="element-198">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}